import { render, staticRenderFns } from "./flash-wrapper.vue?vue&type=template&id=08256bcc&"
import script from "./flash-wrapper.vue?vue&type=script&lang=js&"
export * from "./flash-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports